export var RequestPasswordSetupError;
(function (RequestPasswordSetupError) {
    RequestPasswordSetupError["deactivatedAccount"] = "authentication-account-deactivated";
    RequestPasswordSetupError["expiredAccount"] = "authentication-expired-account";
    RequestPasswordSetupError["unknownEmail"] = "unknown-email";
})(RequestPasswordSetupError || (RequestPasswordSetupError = {}));
var RequestPasswordSetupRequest = /** @class */ (function () {
    function RequestPasswordSetupRequest(email) {
        this.isAuthenticated = false;
        this.knownErrorCodes = Object.values(RequestPasswordSetupError);
        this.method = 'post';
        this.path = 'authentication/password/reset';
        this.body = JSON.stringify({ email: email });
    }
    return RequestPasswordSetupRequest;
}());
export { RequestPasswordSetupRequest };
